/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultBasedAverage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_007: Question = {
  id: 'gov-007-montant-biodiversite',
  oldId: '7',
  title: 'Montant alloué à la biodiversité',
  number: '1.7',
  frequency: 1,
  type: QuestionType.INDICATOR,
  description: ['La liste détaillée des montants alloués annuellement aux ressources humaines et aux activités liées à la préservations de la biodiversité est complétée.'],
  slots: [
    {
      type: SlotTypes.REPEATER,
      items: [''],
      data: [
        {
          secteur: 'Ressources humaines',
          comment: '',
          amount: '0',
        },
        {
          secteur: 'Acquisition de connaissances',
          comment: '',
          amount: '0',
        },
        {
          secteur: 'Action terrain',
          comment: '',
          amount: '0',
        },
        {
          secteur: 'Lutte aux espèces envahissantes',
          comment: '',
          amount: '0',
        },
        {
          secteur: 'Sensibilisation',
          comment: '',
          amount: '0',
        },
        {
          secteur: 'Subventions accordées',
          comment: '',
          amount: '0',
        },
      ],
      repeaterFields: [
        {
          label: 'Secteur',
          slug: 'secteur',
          width: '30%',
        },
        {
          label: 'Montant alloué',
          slug: 'amount',
          width: '25%',
          type: 'number',
        },
        {
          label: 'Commentaire',
          slug: 'comment',
          width: '45%',
        },
      ],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 100) return 4;
        if (data >= 75) return 3;
        if (data >= 50) return 2;
        if (data >= 25) return 1;
        return 0;
      },
      score: '0',
      maxScore: 4,
      help: defaultBasedAverage,
      unit: SlotUnit.DOLLAR_PER_RESIDENT,
    },

  ],
};
const question_gov_007__v3: Question = {
  ...question_gov_007,
  title: 'Montant alloué pour la préservation de la biodiversité',
};

export const question_gov_007_v2: Question = question_gov_007;
export const question_gov_007_v3: Question = question_gov_007__v3;
